// The streak flame: our own two-tone flame (crash-cart orange, lime core) with the count. It flickers while the streak
// lives; `snuffed` puts it out with a puff of smoke when a streak ends.
export function StreakFlame({ n, size = 18, snuffed = false, className = '', showCount = true }: { n: number; size?: number; snuffed?: boolean; className?: string; showCount?: boolean }) {
  return (
    <span className={`rd-flame ${className}`} data-snuffed={snuffed || undefined} role="img" aria-label={snuffed ? `Streak of ${n} ended` : `Streak of ${n}`}>
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12.3 2.2c.5 2.6 2.4 4.1 3.9 5.9 1.9 2.2 3.1 4.6 2.6 7.5-.6 3.6-3.6 6.2-7.2 6.2-3.7 0-6.6-2.8-6.8-6.4-.1-2.3.9-4.4 2.5-6 .2 1.4.8 2.6 1.9 3.3-.4-4.2 1.1-7.9 3.1-10.5Z" fill="currentColor" />
        <path d="M12.4 11.5c.3 1.4 1.4 2.2 2 3.4.8 1.6.3 3.6-1.3 4.4-1.7.9-3.9.1-4.5-1.8-.4-1.2 0-2.4.8-3.3.1.8.5 1.4 1.1 1.7-.2-1.6.6-3.2 1.9-4.4Z" fill="var(--lime)" />
      </svg>
      {snuffed && <span className="rd-flame-puff" aria-hidden="true" />}
      {showCount && <span aria-hidden="true">{n}</span>}
    </span>
  );
}
